import { Controller } from '@hotwired/stimulus';
import ApplicationController, { EVENTO_CONTROLLER_CARGADO } from '../application_controller';
import GestorSeleccionListado from '../utils/GestorSeleccionListado';
import { EVENTO_ANTES_CARGAR } from '../modal_remoto_controller';

/* global $, cloneOnScroll */
export default class extends ApplicationController {
  connect() {
    this.gestorSeleccionListado = new GestorSeleccionListado(this.element);
    this.gestorSeleccionListado.connect();
    this.#conectarBotones();

    $(window).on('scroll', () => {
      this.#clonarCabecerasTablaOnScroll();
    });

    this.$element = $(this.element);
    // Esto no está bien pero lo traigo tal cual estaba
    this.$element.on('change', '[id^=ge_sus_recibos]', function cambiaCheck() {
      const $meses = $('.servicios-alumnos-filtro-meses-wrapper');
      if ($(this).is(':checked')) {
        $meses.removeClass('hide');
      }
    });
  }

  #conectarBotones() {
    console.log('sdfsd');
    
    this.element.querySelectorAll('.btn-asignar-ids').forEach((boton) => {
      console.log('Conectando boton asignar ids');
      boton.addEventListener(EVENTO_ANTES_CARGAR, (event) => {
        const filtros = this.gestorSeleccionListado.getParametrosFiltros();
        Object.keys(filtros).forEach((key) => {
          event.detail.url.searchParams.append(key, filtros[key]);
        });
      });
    });
  }

  /* eslint-disable class-methods-use-this */
  #clonarCabecerasTablaOnScroll() {
    // TODO: No usar esta función global, esto habrá que migrarlo a una clase JS
    cloneOnScroll($(window), $(document.body), '#listado-ge', '#wrapper-gestion-economica', '#wrapper-gestion-economica', false);
  }
}
